import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import { useGlobalComponentsContext } from 'src/contexts/GlobalComponentsContext';
import Dialog, { DialogProps } from '@mui/material/Dialog';

export type OpenDialogSettings = {
  title: string;
  description?: string;
} & Omit<DialogProps, 'open'>;

export function useAlertDialog(id: string) {
  const { union, remove } = useGlobalComponentsContext();
  return {
    open: ({ title, description, ...props }: OpenDialogSettings) => {
      union(
        id,
        <Dialog
          open={true}
          sx={{
            '& .MuiPaper-root': { backgroundColor: 'background.elevation.2' },
          }}
          {...props}
          onClose={(...args) => {
            remove(id);
            if (!!props.onClose) {
              props.onClose(...args);
            }
          }}
        >
          <Alert severity="error" variant="outlined">
            <Typography
              variant="h5"
              color="error.light"
              sx={{ pb: 2, ml: 4, textTransform: 'uppercase' }}
            >
              {title}
            </Typography>{' '}
            <Typography
              color="error.light"
              sx={{ ml: 4, textTransform: 'none', fontWeight: '500' }}
            >
              {description}
            </Typography>
          </Alert>
        </Dialog>,
      );
    },
    close: () => {
      remove(id);
    },
  };
}
